import React from 'react'

export default function Icon ({iconSrc, size=24, style={}, ...props}) {
    return <img src={iconSrc} style={{width: size, height: size, objectFit: 'contain', ...style}} {...props}/>
}
